import React from "react";
import { useParams } from "react-router-dom";
import pageRegistry from "./pageRegistry";
import NotYetMigrated from "../pages/NotYetMigrated/NotYetMigrated";

export default function DynamicPage() {
  const { pageUrl } = useParams();
  const Registered = pageRegistry[pageUrl];
  return Registered ? <Registered /> : <NotYetMigrated />;
}
